import { toast } from 'react-toastify';

export async function downloadExcel(
  fetchFn: () => Promise<any>,
  filename: string,
  setLoading?: (v: boolean) => void
) {
  if (setLoading) setLoading(true);
  try {
    const response = await fetchFn();
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
    toast.success(`Eksport Excel zakończony: ${filename}`);
  } catch (error: any) {
    toast.error(error.response?.data?.message || 'Błąd eksportu Excel');
  } finally {
    if (setLoading) setLoading(false);
  }
}
